import client from '@/services/http/client'
import type {
  ReceptionShareBatch,
  ReceptionShareBatchPage,
  ReceptionShareCreatePayload,
  ReceptionShareCreateResult,
  ReceptionShareGroupPage,
  ReceptionShareUserPage,
} from '@/types/receptionShare'

export async function fetchReceptionShareCandidates(params: {
  kind: 'source' | 'target'
  keyword?: string
  page?: number
  page_size?: number
}): Promise<ReceptionShareUserPage> {
  const { data } = await client.get<ReceptionShareUserPage>('/reception-shares/candidates', { params })
  return data
}

export async function fetchReceptionShareableGroups(params: {
  source_user_id: number
  keyword?: string
  page?: number
  page_size?: number
}): Promise<ReceptionShareGroupPage> {
  const { data } = await client.get<ReceptionShareGroupPage>('/reception-shares/shareable-groups', { params })
  return data
}

export async function fetchReceptionShareBatches(params: {
  status?: string
  keyword?: string
  page?: number
  page_size?: number
}): Promise<ReceptionShareBatchPage> {
  const { data } = await client.get<ReceptionShareBatchPage>('/reception-shares', { params })
  return data
}

export async function fetchReceptionShareBatch(batchId: number): Promise<ReceptionShareBatch> {
  const { data } = await client.get<ReceptionShareBatch>(`/reception-shares/${batchId}`)
  return data
}

export async function createReceptionShare(payload: ReceptionShareCreatePayload): Promise<ReceptionShareCreateResult> {
  const { data } = await client.post<ReceptionShareCreateResult>('/reception-shares', payload)
  return data
}

export async function revokeReceptionShare(batchId: number, reason: string): Promise<ReceptionShareBatch> {
  const { data } = await client.post<ReceptionShareBatch>(`/reception-shares/${batchId}/revoke`, { reason })
  return data
}
